import React from "react";
import livePointerService from "./livePointerService";
import useCheckCallConnected from "../../hooks/useCheckCallConnected";
import { useSelector } from "react-redux";
import { CALL_BODY_SCREEN } from "../../constants/Constants";
import clsx from "clsx";

const LivePointerMwebButton = () => {
    const isCallNotConnected = useCheckCallConnected();
    const { currentCallBodyScreen } = useSelector((state) => state.commonReducer);
    const toggleLivePointer = (fromWhere, msg, toastmsg) => {
        livePointerService.toggleLivePointer(fromWhere, msg, toastmsg);
    };
    return (
        <>
            {livePointerService.isLivePointerButtonAvailable() && (
                <div className='livepointer-shortbutton'>
                    <button
                        className={clsx("btn", livePointerService.checkLivePointerStatus() && "active")}
                        disabled={
                            isCallNotConnected ||
                            !livePointerService.checkLivePointerButtonEnabled() ||
                            currentCallBodyScreen === CALL_BODY_SCREEN.NOTIFY_SCREEN
                        }
                        onClick={() => toggleLivePointer(false, undefined, "1")}
                    >
                        <span
                            className={clsx("for-icon", livePointerService.checkLivePointerStatus() ? "icon-start-pointer" : "icon-pointer")}
                        ></span>
                    </button>
                </div>
            )}
        </>
    );
};

export default LivePointerMwebButton;
